import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'stupa-mobile-search',
  standalone: true,
  imports: [CommonModule, FormsModule,TranslateModule],
  templateUrl: './mobile-search.component.html',
  styleUrl: './mobile-search.component.scss',
})
export class MobileSearchComponent implements AfterViewInit, OnDestroy {
  @ViewChild('overlayRef', { read: ElementRef }) overlayRef!: ElementRef<HTMLElement>;
  @Input() searchQuery: string = '';
  @Output() searchTyping = new EventEmitter<string>();
  @Output() searchSubmit = new EventEmitter<string>();

  ngAfterViewInit(): void {
    if (this.overlayRef?.nativeElement) {
      document.body.appendChild(this.overlayRef.nativeElement);
    }
  }

  ngOnDestroy(): void {
    const el = this.overlayRef?.nativeElement;
    if (el?.parentNode) {
      el.remove();
    }
  }

  onTyping(value: string) {
    this.searchTyping.emit(value);
  }

  onEnter(event: any) {
    
    this.searchQuery = event.target.value;
    if (event.keyCode === 13 || event.key === 'Enter') {
      event.preventDefault();
      this.searchSubmit.emit(this.searchQuery);
    }
  }

  close() {
    this.searchSubmit.emit('');
  }
}
